// extracted by mini-css-extract-plugin
export default {"field-clashers-home-background":"FieldClashersHome_field-clashers-home-background__-e0XN","markdown":"FieldClashersHome_markdown__LJJsC"};